import * as React from 'react';
import { uploadVideo } from '../cloudinary';
import FileContainer from './FileContainer';

interface UploadVideoProps {
    tags: string;
    folder: string;
    onNewVideoUpload: (id: string) => void;
}

interface UploadVideoState {
    state: State;
    message: string;
    progressPercent: number;
}

enum State {
    NONE,
    RECORDING,
    RECORDED,
    UPLOADING,
    UPLOADED
}

class UploadVideo extends React.Component<UploadVideoProps, UploadVideoState> {
    public constructor(props) {
        super(props);
        this.state = {
            state: State.NONE,
            message: '',
            progressPercent: 0
        };
    }

    private async handleVideoFromFilesystem(files) {
        this.setState({ state: State.UPLOADING });
        try {
            const publicId = await uploadVideo(this.props.tags, this.props.folder, files[0], progressPercent => {
                this.setState({ progressPercent, state: State.UPLOADING });
            });
            this.setState({ progressPercent: 100, state: State.UPLOADED });
            this.props.onNewVideoUpload(publicId);
        } catch (err) {
            this.setState({ message: err.message });
        }
    }

    public render() {
        return (
            <div>
                <FileContainer>
                    Record or upload a video
                    <input
                        id="video_upload"
                        type="file"
                        accept="video/mp4,video/x-m4v,video/*"
                        onChange={e => this.handleVideoFromFilesystem(e.target.files)}
                    />
                </FileContainer>
                {this.state.state === State.UPLOADING && <div>Uploading... {this.state.progressPercent}%</div>}
            </div>
        );
    }
}

export default UploadVideo;



// WEBPACK FOOTER //
// ./src/components/UploadVideo.tsx